<template>
  <v-fade-transition>
    <span v-if="state" class="save-status" :class="state">
      <v-progress-circular v-if="state === 'saving'" indeterminate size="14" width="2" class="mr-1"></v-progress-circular>
      <v-icon v-else-if="state === 'saved'" small color="success" class="mr-1">mdi-check</v-icon>
      <v-icon v-else small color="error" class="mr-1">mdi-alert-circle-outline</v-icon>
      {{ state === 'saving' ? 'Saving…' : state === 'saved' ? 'Saved' : 'Not saved' }}
    </span>
  </v-fade-transition>
</template>

<script>
// The "Saving… / Saved / Not saved" indicator in the title of the settings cards, driven by the company_settings mixin.
export default {
  props: {
    state: { type: String, default: '' },   // '' | 'saving' | 'saved' | 'error'
  },
}
</script>

<style lang="scss" scoped>
.save-status {
  display: inline-flex;
  align-items: center;
  font-size: 0.8rem;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);

  &.error { color: var(--v-error-base); }
}
</style>
